
export default {
  props: {
    main: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    const arr = []
    arr.push({ // 法定名称
      name: this.$t('54883'),
      icon: 'icon-bank',
      type: '1',
      val: this.main.legalName
    })

    arr.push({ // 登记状态
      name: this.$t('54792'),
      icon: 'icon-search-status',
      type: '1',
      val: this.main.registrationStatusName
    })

    arr.push({ // 成立日期
      name: this.$t('36735'),
      icon: 'icon-search-status',
      type: '1',
      val: this.main.establishedAt
    })

    arr.push({ // 司法辖区：
      name: this.$t('54791'),
      icon: 'icon-search-status',
      type: '1',
      val: this.main.jurisdictionName
    })

    arr.push({ // 是否分支机构：
      name: this.$t('54890'),
      icon: 'icon-search-status',
      type: '1',
      val: this.main.isBranchStructure ? this.$t('21316') : this.$t('21317')
    })

    arr.push({ // 商业登记号
      name: this.$t('54886'),
      icon: 'icon-document-text2',
      type: '1',
      val: this.main.businessRegistrationNumber
    })

    arr.push({ // 注册信息来源
      name: this.$t('54885'),
      icon: 'icon-search-status',
      type: '1',
      val: this.main.registrationSource
    })

    arr.push({ // 解散日期
      name: this.$t('54887'),
      icon: 'icon-note-remove',
      type: '1',
      val: this.main.dissolutionDate
    })
    arr.push({ // 最新年审日期
      name: this.$t('55289'),
      icon: 'icon-receipt-2',
      type: '1',
      val: this.main.latestMadUpDate || '--'
    })
    arr.push({ // 曾用名
      name: this.$t('20636'),
      icon: 'icon-pen-add',
      type: this.main.formerName?.length > 0 ? '2' : '1',
      val: this.main.formerName?.length > 0 ? this.main.formerName : '--'
    })
    arr.push({ // 行业代码
      name: this.$t('54888'),
      icon: 'icon-receipt-2',
      type: this.main.industryCodes?.length > 0 ? '2' : '1',
      val: this.main.industryCodes?.length > 0 ? this.main.industryCodes : '--'
    })

    // this.main?.invests?.forEach((item) => {
    //   if (item.key == 0) { // 官方QQ
    //     arr.push({
    //       name: this.$t('22347'),
    //       icon: 'icon-Frame30',
    //       type: '0',
    //       val: item.values
    //     })
    //   } else if (item.key == 1) { // 客服电话
    //     arr.push({
    //       name: this.$t('20827'),
    //       icon: 'icon-a-Phone-calldianhuahujiao',
    //       type: '2',
    //       val: item.values
    //     })
    //   } else if (item.key == 2) { // Facebook
    //     arr.push({
    //       name: 'Facebook',
    //       icon: 'icon-Facebook',
    //       type: '2',
    //       val: item.values
    //     })
    //   } else if (item.key == 3) { // 客服邮箱
    //     // arr.push({
    //     //   name: this.$t('22093'),
    //     //   icon: 'icon-sms2',
    //     //   type: '2',
    //     //   val: item.values
    //     // })
    //   } else if (item.key == 5) { // X
    //     arr.push({
    //       name: 'X',
    //       icon: 'icon-X',
    //       type: '2',
    //       val: item.values
    //     })
    //   } else if (item.key == 6) { // 官方WeChat
    //     arr.push({
    //       name: this.$t('54889'),
    //       icon: 'icon-weixingongzhonghao',
    //       type: '2',
    //       val: item.values
    //     })
    //   } else if (item.key == 7) { // Instagram
    //     arr.push({
    //       name: 'Instagram',
    //       icon: 'icon-Instagram',
    //       type: '2',
    //       val: item.values
    //     })
    //   } else if (item.key == 8) { // Youtube
    //     arr.push({
    //       name: 'Youtube',
    //       icon: 'icon-Youtube',
    //       type: '2',
    //       val: item.values
    //     })
    //   } else if (item.key == 9) { // Linkedin
    //     arr.push({
    //       name: 'Linkedin',
    //       icon: 'icon-LinkedIn',
    //       type: '2',
    //       val: item.values
    //     })
    //   } else if (item.key == 10) { // WhatsApp
    //     arr.push({
    //       name: 'WhatsApp',
    //       icon: 'icon-Frame31',
    //       type: '2',
    //       val: item.values
    //     })
    //   }
    // })

    // arr.push({ // 是否分支机构
    //   name: this.$t('54890'),
    //   icon: 'icon-layer',
    //   type: '2',
    //   val: this.main.isBranchStructure ? this.$t('21316') : this.$t('21317')
    // })
    return {
      show: false,
      list: arr,
      alllist: arr
    }
  },
  computed: {
  },
  methods: {
    taggerfn () {
      if (this.show) {
        this.list = this.alllist?.slice(0, 6)
      } else {
        this.list = this.alllist
      }
      this.show = !this.show
    }
  }
}
